
import { Component, Vue } from 'vue-property-decorator'
import STextField from '@/components/STextField.vue'
import SButton from '@/components/SButton.vue'
import { UserModel } from '@/store/models/UserModel'

@Component({
  components: { SButton, STextField },
})
export default class Information extends Vue {
  user: UserModel = UserModel.getInstance()
  address: string = ''
  city: string = ''
  country: string = ''
  disableBtn: boolean = false
  nameLabel: string = ''

  mounted() {
    this.fetchUserAddress()
  }
  saveChanges() {
    this.disableBtn = true
    this.user.saveToServer(
      () => {
        this.disableBtn = false
        this.nameLabel = this.user.getFullName()
      },
      () => {
        this.disableBtn = false
      }
    )
  }
  fetchUserAddress() {
    this.user.load(false, () => {
      const filteredAddress = this.user.addresses.filter(
        (item: any) => item.is_default
      )

      this.address = filteredAddress[0] ? filteredAddress[0].address : ''
      this.city = filteredAddress[0] ? filteredAddress[0].city : ''
      this.country = filteredAddress[0] ? filteredAddress[0].country : ''

      this.nameLabel = this.user.getFullName()
    })
  }
}
